import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { ItemChecklistServico } from "../../../../domain/models/item_checklist_servico";
import { ItemChecklistServicoForm, ItemChecklistServicoSchema } from "../../../schemas/ChecklistServicoItens_cadastro/item_checklist_servico";

import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";

/**
 * ItemChecklistServicoModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedItemChecklistServico: ItemChecklistServico | null,
  onClose: (idItemChecklistServico: number | null, openState: boolean) => void;
  onSubmit: (form: ItemChecklistServicoForm) => void;
};

export const ItemChecklistServicoModal = ({
  open,
  saving,
  loading,
  selectedItemChecklistServico,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(ItemChecklistServicoSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectedItemChecklistServico) {
        hookForm.setValue('ordem', selectedItemChecklistServico.ordem ?? '');
        hookForm.setValue('descricao', selectedItemChecklistServico.descricao ?? '');
        hookForm.setValue('resumoItem', selectedItemChecklistServico.resumoItem ?? '');
        hookForm.setValue('metodoVerificacao', selectedItemChecklistServico.metodoVerificacao ?? '');
        hookForm.setValue('tolerancia', selectedItemChecklistServico.tolerancia ?? '');
      } else {
        hookForm.reset();
      }
    }
  }, [
    open,
    selectedItemChecklistServico,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      width="50rem"
      title='Checklist de serviço'
      onClose={() => onClose(null, false)}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col">
        <FormContainer title='Informações' arrangement='fullRow' gap='small' border={false}>
          <>
            <DefaultFormInput
              name='ordem'
              label='Ordem'
              readOnly={saving}
              required={true}
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name='descricao'
              label='Descrição do Item'
              readOnly={saving}
              required={true}
              multiline={true}
              rows={3}
              reactHookForm={hookForm}
            />

            <div className="w-full flex flex-col">
              <DefaultFormInput
                name='metodoVerificacao'
                label='Método de verificação'
                readOnly={saving}
                multiline={true}
                rows={5}
                reactHookForm={hookForm}
              />
            </div>

            <DefaultFormInput
              name='tolerancia'
              label='Tolerância'
              readOnly={saving}
              multiline={true}
              rows={5}
              reactHookForm={hookForm}
            />

            <div className="w-full flex flex-col">
              <DefaultFormInput
                name='resumoItem'
                label='Resumo do Item'
                readOnly={saving}
                reactHookForm={hookForm}
              />
              <span className="text-red-500 text-sm">
                Esse campo é para resumir o item a ser inspecionado, deve conter no máximo 25 caracteres.
              </span>
            </div>
          </>
        </FormContainer>
      </div>
    </BaseFormControlledModal >
  );
}
